import chevronRight from '@/assets/icons/icon-chevron-right.svg';
import { decodeHtmlEntities } from '@/utils/decodeHtmlEntities';
import './Breadcrumb.scss';

export interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  const filtered = items.filter((item) => item.name?.trim());
  if (filtered.length === 0) return null;

  const allItems: BreadcrumbItem[] = [{ name: 'Accueil', href: '/' }, ...filtered];
  return (
    <nav className="breadcrumb" aria-label="Fil d'Ariane">
      <ol className="breadcrumb__list">
        {allItems.map((item, index) => (
          <li key={index} className="breadcrumb__item">
            {item.href ? <a href={item.href}>{decodeHtmlEntities(item.name)}</a> : decodeHtmlEntities(item.name)}
            {index < allItems.length - 1 && (
              <img
                className="breadcrumb__separator"
                src={chevronRight}
                alt=""
                aria-hidden="true"
                width={16}
                height={16}
              />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
